import { Component, OnInit } from '@angular/core';
import { RemoteService } from 'app/services/remote.service';
import { LocalStorageService } from 'ngx-store';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  home: FormGroup;
  formSumitAttempt: boolean;
  constructor(private remoteService: RemoteService,
    private ls: LocalStorageService,
    private fb: FormBuilder,
    private notifierService: NotifierService,
    private datePipe: DatePipe) { }

  ngOnInit() {
    try {
      //@ts-ignore
      $('.slider1').bxSlider({
        slideWidth: 200,
        minSlides: 2,
        maxSlides: 4,
        slideMargin: 10
      });
    } catch (e) { }
    this.home = this.fb.group({
      email: ['', [Validators.required, Validators.pattern('^[a-z0-9A-Z.!#$%^&+;*_)(-]{3,}[@]{1}[a-z]{2,}[.]{1}[a-z]{2,}$')]],
    })
    if (this.ls.get('access_token')) {
      return this.remoteService.userNavigateTodashboard();
    }
    this.remoteService.scrollingtoNavbar();
  }

  isFieldValid(field: string) {
    return (
      (!this.home.get(field).valid && this.home.get(field).touched) ||
      (this.home.get(field).untouched && this.formSumitAttempt)
    );
  }

  submit() {
    if (this.home.valid) {
      const payload = {
        email: this.home.value.email,
        subscriptionType: 'newsletter',
        dateSubscribed: this.datePipe.transform(new Date(), 'yyyy-MM-dd')
      }
      this.remoteService.subscribeEmail(payload).subscribe(res => {
        this.notifierService.notify('success', 'Email subscribed successfully!');
      }, error => {
        this.notifierService.notify('error', error);
      })
    } else {
      this.notifierService.notify('error', 'Invalid Inputs!');
    }
  }
}
